import React from "react";

import { StyledSVG } from "../StyledIcon";

export const LinkedInIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 23 24"
      fill="none"
      {...props}
    >
      <path d="M25.124 3.97131C25.7819 3.97131 26.4129 4.23266 26.8781 4.69786C27.3433 5.16305 27.6046 5.794 27.6046 6.45189V23.8159C27.6046 24.4738 27.3433 25.1047 26.8781 25.5699C26.4129 26.0351 25.7819 26.2965 25.124 26.2965H7.75967C7.10177 26.2965 6.47082 26.0351 6.00561 25.5699C5.5404 25.1047 5.27905 24.4738 5.27905 23.8159V6.45189C5.27905 5.794 5.5404 5.16305 6.00561 4.69786C6.47082 4.23266 7.10177 3.97131 7.75967 3.97131H25.124ZM24.5039 23.1958V16.6222C24.5039 15.5499 24.0779 14.5214 23.3196 13.7632C22.5613 13.0049 21.5328 12.5789 20.4604 12.5789C19.4062 12.5789 18.1783 13.2239 17.5829 14.1913V12.8146H14.1225V23.1958H17.5829V17.0811C17.5829 16.1261 18.3519 15.3447 19.307 15.3447C19.7675 15.3447 20.2092 15.5277 20.5348 15.8533C20.8605 16.179 21.0434 16.6206 21.0434 17.0811V23.1958H24.5039ZM10.0915 10.8673C10.6441 10.8673 11.1741 10.6478 11.5649 10.257C11.9556 9.86625 12.1752 9.33625 12.1752 8.78363C12.1752 7.63016 11.2449 6.68754 10.0915 6.68754C9.53553 6.68754 9.00237 6.90838 8.60927 7.30147C8.21617 7.69456 7.99533 8.22771 7.99533 8.78363C7.99533 9.93709 8.93797 10.8673 10.0915 10.8673ZM11.8155 23.1958V12.8146H8.37983V23.1958H11.8155Z"
      fill={iconColor}
      vector-effect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
